import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
// utils
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  resendOtpData: null,
  loginData: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: false,
      user,
    };
  },
  OTP_VERIFY: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  RESEND_OTP: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: false,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  verifyOtp: () => Promise.resolve(),
  resendOtp: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessTokenTalent');
        if (accessToken) {
          setSession(accessToken);
          const { user } = [];

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (username, password) => {
    const response = await axios.post('/login/', {
      username,
      password,
      // agent_id,
    });
    if (response && response.data && response.data.status === 200) {
      const { accessToken, user } = response.data;
      // window.localStorage.setItem('accessToken', response && response.data.response && response.data.response.access_token);
      setSession(
        response && response.data.response && response.data.response.access_token,
        response && response.data.response && response.data.response.user,
        response && response.data.response && response.data.response.menus,
        response && response.data.response && response.data.response.agent_id,
        response && response.data.response && response.data.response.enc_agent_id
      );
      dispatch({
        type: 'LOGIN',
        payload: {
          user: response.data,
        },
      });
    } else {
      console.log('after error');
    }
  };

  const register = async (regVal) => {
    const response = await axios.post('/registration/', regVal);
    const { accessToken, user } = response.data;
    if (response && response.data && response.data.status === 200) {
      window.localStorage.setItem('resBody', JSON.stringify(response.data));
      window.localStorage.setItem('access_token', response.data.response.access_token);
      dispatch({
        type: 'REGISTER',
        payload: {
          user: response.data,
        },
      });
    } else {
      console.log('after error');
    }
  };

  const verifyOtp = async (otpVal) => {
    const tokenVal = window.localStorage.getItem('access_token');
    const response = await axios.post('/verifyOtp/', otpVal);
    if (response && response.data && response.data.status === 200) {
      const { accessToken, user } = response.data;
      setSession(
        response && response.data.response && response.data.response.access_token,
        response && response.data.response && response.data.response.user,
        response && response.data.response && response.data.response.menus,
        response && response.data.response && response.data.response.agent_id,
        response && response.data.response && response.data.response.enc_agent_id
      );
      dispatch({
        type: 'OTP_VERIFY',
        payload: {
          user: response.data,
        },
      });
    } else {
      console.log('after error');
    }
  };

  const resendOtp = async (resendOtpVal) => {
    const response = await axios.post('/resendOtp/', resendOtpVal);
    const { accessToken, user } = response.data;
    dispatch({
      type: 'RESEND_OTP',
      payload: {
        resendOtpData: response.data,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    localStorage.removeItem('accessTokenTalent');
    localStorage.removeItem('userPhotourl');
    localStorage.removeItem('userDisplayName');
    localStorage.removeItem('userSlug');
    localStorage.removeItem('userEncId');
    localStorage.removeItem('leftMenu');
    localStorage.removeItem('agentIdLogin');
    localStorage.removeItem('agentEncIdLogin');
    localStorage.removeItem('agentUserSlug');
    localStorage.removeItem('statususer');
    localStorage.removeItem('agentMappingID');
    localStorage.removeItem('CreateagentData');
    localStorage.removeItem('userAgentId');
    localStorage.removeItem('agentIdLogin');
    localStorage.removeItem('userSlugVerify');
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        verifyOtp,
        resendOtp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
